export default {"src":"/_next/static/media/contractor-match.b9a29579.svg","height":25,"width":22,"blurWidth":0,"blurHeight":0};